import {observer} from 'mobx-react';
import {dateSpan} from 'shared/tools';
import {Table} from 'main/components';
import _ from 'lodash';
import {FormattedMessage} from 'react-intl';

const visibleColumns = (fieldUpdates) => {
  const cols = new Set();

  fieldUpdates.forEach(fieldUpdate => {
    Object.entries(fieldUpdate).forEach(([hourType, hours]) => {
      if (hours !== null) cols.add(hourType);
    });
  });

  return cols;
};

const columns = (visibleColumns) => {
  const cols = [{
    header: 'nmbr.updates.directory.Effective Period',
    width: 3,
    render: model => dateSpan(model.startDate, model.endDate)
  }];

  if (visibleColumns.has('regular')) {
    cols.push({
      header: 'nmbr.updates.directory.Regular',
      width: 2,
      attribute: 'regular'
    });
  }
  if (visibleColumns.has('overtime')) {
    cols.push({
      header: 'nmbr.updates.directory.Overtime',
      width: 1.5,
      attribute: 'overtime'
    });
  }
  if (visibleColumns.has('doubleOvertime')) {
    cols.push({
      header: 'nmbr.updates.directory.Double Overtime',
      width: 1.5,
      attribute: 'doubleOvertime'
    });
  }
  if (visibleColumns.has('holiday')) {
    cols.push({
      header: 'nmbr.updates.directory.Holiday',
      width: 2,
      attribute: 'holiday'
    });
  }
  if (visibleColumns.has('vacation')) {
    cols.push({
      header: 'nmbr.updates.directory.Paid Time Off',
      width: 2,
      attribute: 'vacation'
    });
  }

  const unusedWidth = 12 - _.sumBy(cols, 'width');
  _.last(cols).width += unusedWidth;

  return cols;
};

const SyncedHoursTable = observer(({nmbrUpdate}) => {
  if (!nmbrUpdate.hasFieldUpdate('synced_hours')) return null;

  return (
    <div className='space-y'>
      <div className='h4 medium'><FormattedMessage id='nmbr.updates.directory.Hours Worked'/></div>
      <Table
        columns={columns(visibleColumns(nmbrUpdate.fieldUpdatesForType('synced_hours')))}
        models={nmbrUpdate.fieldUpdatesForType('synced_hours')}
        showLinks={false}
      />
    </div>
  );
});

export default SyncedHoursTable;
